import { useNavigate } from "react-router-dom";

import { CommoditySwitch } from "@/components/market-intelligence/CommoditySwitch";
import { overviewPath } from "@/lib/market-intelligence/paths";
import { useMarketCommodityScope } from "@/lib/market-intelligence/region-nav";

import type { MarketCommodity } from "@/types/market-intelligence";

/**
 * The sidebar's Electric/Gas switch — the module's own header content, wired in
 * via `ModuleDefinition.sidebarHeader`.
 *
 * Drives the whole module's nav, not just the Overview page: selecting Gas
 * swaps the sidebar's region picker + region section for the flat gas-hub
 * section (`ModuleSection.visibleWhen`, keyed off the same
 * `useMarketCommodityScope` this reads), and always lands on the Overview so
 * there is one page both commodities agree on. This replaced a page-level
 * toggle that lived only on the Overview — a control that changes which
 * whole SECTION of the sidebar applies belongs in the sidebar, not on one
 * page beneath it.
 *
 * Drawn by `CommoditySwitch`, which the report point pickers' quick filters
 * reuse; its styling notes live there.
 */
export function MarketCommodityToggle() {
  const navigate = useNavigate();
  const commodity = useMarketCommodityScope();

  /**
   * `"power"` is the DATA value (as stored and CHECKed in every `market.*`
   * table); "Electric" is what the label and the url say. The two vocabularies
   * meet only in `COMMODITY_SLUG` — see `paths.ts`. Do not rename the value
   * here to match the label.
   */
  const go = (next: MarketCommodity) => {
    navigate(overviewPath(next));
  };

  return <CommoditySwitch value={commodity} onChange={go} />;
}
